import React from "react";
import { Select, MenuItem, Button, Container } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import DataPickerAtualizado from "../../../components/DataPickerAtualizado";
import "./styles.css";

export default function SelecionarVisualizacao({
  setSituacao,
  situacao,
  dataFim,
  setDataFim,
  onAdicionarAmostra,
}) {
  return (
    <Container maxWidth="md">
      <div className="container">
        <div className="grid-container-Dom-vis">
          <div className="grid-item" md="4">
            <DataPickerAtualizado
              data={dayjs(dataFim)}
              setData={setDataFim}
              variant="inline"
              labelName="Data"
            />
          </div>
          <div className="grid-item" md="4">
            <Select
              labelId="novo-filtro-valor-label"
              id="novo-filtro-valor"
              label="Valor"
              value={situacao}
              onChange={(e) => setSituacao(e.target.value)}
            >
              <MenuItem value="pendente">Pendentes</MenuItem>
              <MenuItem value="concluido">Concluídos</MenuItem>
            </Select>
          </div>
          <div className="grid-item" md="4">
            <Button
              type="button"
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onAdicionarAmostra}
              className="button-adicionar-amostra"
            >
              Adicionar Amostra
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
}
